export default __webpack_public_path__ + "static/media/xml.dddd314b.svg";